import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { FileType } from '../../../../../shared/constants/download.constants';
import { getCanvasIdForAllCharts } from '../../../../../shared/helpers/chart-helper';
declare const html2canvas: any;

@Component({
  selector: 'app-download-all-charts-icon',
  templateUrl: './download-all-charts-icon.component.html',
  styleUrls: ['./download-all-charts-icon.component.less']
})
export class DownloadAllChartsIconComponent implements OnInit {
  @Input() canvas: ElementRef;
  @Input() questionId: number;
  @Input() questionNumber: number;
  @Input() surveyVersionName: string;
  @Input() surveyTitle: string;

  downloadType = 0;
  showDropdownDownload = false;
  showLoader = false;
  imageURL = '';
  showClipboard = false;

  private listening = false;
  private globalClick: any;

  constructor(private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  displayDropdownDownload(element) {
    if (element.target['tagName'] === 'INPUT' || element.target['tagName'] === 'LABEL') return;

    this.showDropdownDownload = !this.showDropdownDownload;
    if (this.showDropdownDownload) {
      this.globalClick = Observable
        .fromEvent(document, 'click')
        .delay(100)
        .do(() => {
          this.listening = true;
        }).subscribe((event: MouseEvent) => {
          this.onGlobalClick(element, event);
        });
    } else {
      this.listening = false;
      this.globalClick.unsubscribe();
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownDownload = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  selectedDownload(fileExtension: string): void {
    if (this.downloadType === 0) {
      this.downloadThisChart(fileExtension);
    } else {
      this.downloadAllCharts(fileExtension);
    }
  }

  downloadThisChart(fileExtension: string) {
    const surveyVersionName = this.surveyVersionName;
    const questionNumber = ("000" + this.questionNumber).slice(-3);
    html2canvas(this.canvas.nativeElement, { backgroundColor: null }).then(canvas => {
        window.saveAs(canvas.toDataURL(), `Q${questionNumber} ${surveyVersionName}.${fileExtension}`);
    });
  }

  downloadAllCharts(fileExtension: string): void {
    const surveyTitle = this.surveyTitle;
    const questionNumber = ("000" + this.questionNumber).slice(-3);
    const filter = {
      backgroundColor: null,
      ignoreElements: function (element) {
        return element.classList.contains('no-print');
      }
    }

    html2canvas(document.getElementById(getCanvasIdForAllCharts(this.questionId)), filter).then(canvas => {
      window.saveAs(canvas.toDataURL(), `Q${questionNumber} ${surveyTitle}.${fileExtension}`);
    });
  }

  get FileType(): typeof FileType {
    return FileType
  }
}






// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/download-all-charts-icon/download-all-charts-icon.component.ts